import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { path } from 'ramda';
import Breadcrumbs from '../../common/Breadcrumbs';
import {
  getHistory,
} from '../../api/quotes';
import Preloader from "../../common/Preloader";
import './style.css';

export class QuoteLogs extends Component {

  constructor(props) {
    super(props);
    this.build = this.build.bind(this);
  }

  state = {
    loading: true
  };

  componentDidUpdate() {
    const historyUpdated = path([ 'quotes', 'historyUpdated' ], this.props);
    const { loading } = this.state;
    if ( loading && historyUpdated ) {
      this.setState({ loading: false });
    }
  }
  componentWillMount() {
    const id = path(['match', 'params', 'id'], this.props);

    this.props.taskHistory(id);
  }

  build() {
    const arrResult = [];
    const historyUpdated = path(['quotes', 'historyUpdated'], this.props) || null;

    if (historyUpdated) {
      let parsed = JSON.parse(historyUpdated);
      if (parsed && parsed.data) {
        for (let i = 0; i < parsed.data.length; i++) {
          arrResult.push(
            <div key={i} dangerouslySetInnerHTML={{ __html: parsed.data[i].html }}></div>
          );
        }
      }
    }

    return arrResult;
  }

  render() {
    const id = path(['match', 'params', 'id'], this.props);
    const {loading} = this.state;
    const mainPart = loading ? <Preloader show={true} type='circle'/> : this.build();
    return (
      <div style={{ paddingBottom: '25px' }}>
        <Breadcrumbs list={[
         { url: '/pages/dashboards', icon: 'dashboard', name: 'Dashboard' },
         { url: '/pages/quotes-edit/' + id, icon: 'library_books', name: 'Quote' },
         { icon: 'mode_comment', name: 'Logs' },
        ]} />
        <div>{mainPart}</div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return state;
};

const mapDispatchToProps = (dispatch) => {
  return {
    taskHistory: (id) => {
      getHistory(id)(dispatch);
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(QuoteLogs);



// WEBPACK FOOTER //
// ./src/containers/QuoteLogs/index.js